export default {
  id: "credential-order-reference",
  name: "Credential Order Reference",
  settings: {}
};
